import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"


//components
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';

//api
import { TemplateService } from "../../../../service/template-service"

const TemplateList = ({reloadList})=>{
    const navigate = useNavigate()
    const [templates, setTemplates]= useState([])

    useEffect(()=>{
        const fetchTemplate = ()=>{
            TemplateService.getAllTemplates(
                (data)=>{
                    if (data && Array.isArray(data.results)) {
                        setTemplates(data.results); 
                    }else{
                        const errorMessage = "La risposta non contiene un array valido di prompt.";
                        console.error(errorMessage);
                    }
                },
                (error)=>{
                    console.error('Errore durante il recupero dei prompt: ', error);
                }
            );
        };
        fetchTemplate();
    },[reloadList])

    return (
        <div className='template__ComponentWrapper'>
            <h3>Lista dei Template</h3>
                <div className="card ">
                    <DataTable value={templates} tableStyle={{ minWidth: '50rem' }} style={{marginRight:'2rem'}}>
                        <Column field="name" header="Nome Template"></Column>
                        <Column field="description" header="Descrizione"></Column>
                        <Column
                            header=""
                            body={(rowData) => (
                                <Button
                                    label="Gestisci"
                                    className="p-button-sm"
                                    onClick={() => {
                                        const templateId = rowData.id;
                                            navigate(`/dashboard/template/${templateId}`);
                                    }}
                                />
                            )}
                        ></Column>
                    </DataTable>
                </div>
            </div>
    )
}

export default TemplateList